/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_None_ToastInputs */



/**
* | output |
* | --- |
* | "No changes could be applied automatically" |
*
* @param {Qc_Fix_None_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_none_toast = /** @type {((inputs?: Qc_Fix_None_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_None_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune modification n'a pu être appliquée automatiquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es konnten keine Änderungen automatisch angewendet werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna modifica applicabile automaticamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось применить изменения автоматически")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo aplicar ningún cambio automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法自动应用任何更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動的に適用できる変更はありませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई बदलाव स्वचालित रूप से लागू नहीं किया जा सका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível aplicar alterações automaticamente")
	return /** @type {LocalizedString} */ ("No changes could be applied automatically")
});